export default __webpack_public_path__ + "static/media/F0006.d5f2b04a.png";